import { render, staticRenderFns } from "./BotaoDeclararVencedor.vue?vue&type=template&id=27786d08&scoped=true"
import script from "./BotaoDeclararVencedor.vue?vue&type=script&lang=js"
export * from "./BotaoDeclararVencedor.vue?vue&type=script&lang=js"
import style0 from "./BotaoDeclararVencedor.vue?vue&type=style&index=0&id=27786d08&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27786d08",
  null
  
)

export default component.exports